export type SubitemKind = 'sublimit' | 'subretention';

export const subitemKindLabels: Record<SubitemKind, string> = {
  sublimit: 'Sublimit',
  subretention: 'Subretention',
};

export const subitemLabel = (kind: SubitemKind, typeName: string): string => `${subitemKindLabels[kind]} — ${typeName}`;

export interface PolicySublimit {
  id: number;
  policyId: number;
  policyLineId: number;
  sublimitTypeId: number;
  name: string;
  value: number;
  originalValue?: number;
}

export interface PolicySubretention {
  id: number;
  policyId: number;
  policyLineId: number;
  subretentionTypeId: number;
  name: string;
  value: number;
  basis?: string;
  originalValue?: number;
}

// A selectable SublimitType / SubretentionType, already scoped by the API to the policy line's
// coverage type and filtered of types the line already carries.
export interface SubitemTypeRef {
  id: number;
  name: string;
}
